
import { Component, Prop, Vue } from 'vue-property-decorator';

  @Component
export default class Grid extends Vue {
  @Prop() readonly cols!: number | string;

  get numbersColumns() {
    return Number(this.cols);
  }
}
